// Returns null when there is no active session: the `_authenticated` guard
// already redirects, so reaching this handler without one means it expired.

import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';
import { z } from 'zod';

import type { TalentSummary } from '../domain/types';

const inputSchema = z.object({ archived: z.boolean().default(false) });

export const listTalentServerFn = createServerFn({ method: 'GET' })
	.inputValidator((data: unknown) => inputSchema.parse(data))
	.handler(async ({ data }): Promise<readonly TalentSummary[] | null> => {
		const { getServerAuthService } = await import(
			'../../authentication/composition.server'
		);
		const { getServerTenancyService } = await import(
			'../../../_shared/tenancy/composition.server'
		);
		const { getServerRosterManagement } = await import('../composition.server');

		const scope = await getServerAuthService().resolveTenantScope(getRequest());
		if (!scope) return null;

		const tenancy = getServerTenancyService();
		const roster = await getServerRosterManagement();
		return tenancy.withTenant(scope.clubId, () =>
			roster.listTalent({ archived: data.archived }),
		);
	});
